import { useEffect, useRef } from 'react';
import { Stage, useAutoUpdateSearchParams } from './useAutoUpdateSearchParams';
import { useAtom } from 'jotai';
import {
    baseUsageAtom,
    zipCodeAtom,
    yearBuiltAtom,
    sqftAtom,
    hhSizeAtom,
    basicInfoExpandAtom,
    utilityCoAtom,
} from '../atoms/form-atoms';

// Auto-open basic info menu when some data is missing.
export function useAutoOpenBasicInfo(enable: boolean) {
    const [baseUsage, setBaseUsage] = useAtom(baseUsageAtom);
    const [zipCode, setZipCode] = useAtom(zipCodeAtom);
    const [yearBuilt, setYearBuilt] = useAtom(yearBuiltAtom);
    const [sqft, setSqft] = useAtom(sqftAtom);
    const [hhSize, setHhSize] = useAtom(hhSizeAtom);
    const [utilityCo, setUtilityCo] = useAtom(utilityCoAtom);

    const [basicInfoExpand, setBasicInfoExpand] = useAtom(basicInfoExpandAtom);
    const initDone = useRef(false);

    useEffect(() => {
        if (!enable) return;

        if (initDone.current) return;
        initDone.current = true;

        if (
            (!basicInfoExpand && !baseUsage) ||
            !zipCode ||
            !yearBuilt ||
            !sqft ||
            !hhSize ||
            !utilityCo
        ) {
            setBasicInfoExpand(true);
        }
    }, [
        baseUsage,
        basicInfoExpand,
        enable,
        hhSize,
        setBasicInfoExpand,
        sqft,
        utilityCo,
        yearBuilt,
        zipCode,
    ]);
}
